import {AddressService} from "./AddressService";
import { Address } from "../types/Address";
import {AddressesV1Addresses} from "./AddressesV1Addresses";

export class AddressServiceImpl implements AddressService {

    constructor(private api: AddressesV1Addresses) {
        
    }

    getAddress(id: string): Promise<Address> {
        return this.api.getAddress(id);
    }

}